import { Component, OnInit } from '@angular/core';

import * as firebase from 'firebase';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  month: string = "Apr";

  stats = {
    usersCount: 0,
    postsCount: 0,
    adsViewCount: 0,
    feedbacksCount: 0,
    sponsorViews: 0
  };

  constructor() { }

  ngOnInit() {
    this.filter();
  }

  filter() {
    var monthNum = this.getMonth(this.month);

    var date = new Date();

    date.setMonth(monthNum, 1);

    date.setHours(0, 0, 1);

    var start = date.getTime();

    date.setMonth(monthNum + 1, 0);

    date.setHours(23, 59, 59);

    var end = date.getTime();

    this.countNewUsers(start, end);
    this.countNewPosts(start, end);
    this.countNewFeedbacks(start, end);
    this.countBannerViews();
  }

  countNewUsers(start, end) {
    debugger;
    firebase.database().ref('users')
      .orderByChild("createdAt")
      .startAt(start)
      .endAt(end)
      .once("value")
      .then(snapshot => {
        var data = snapshot.val();

        if (!data) {
          this.stats.usersCount = 0;
          return;
        }

        var count = 0;

        for (var key in data) {
          count++;
        }

        this.stats.usersCount = count;
      })
      .catch(err => {
        alert(err.message);
        console.log(err);
      })
  }

  countNewPosts(start, end) {
    firebase.database().ref('posts')
      .orderByChild("timestamp")
      .startAt(start)
      .endAt(end)
      .once("value")
      .then(snapshot => {
        var data = snapshot.val();

        if (!data) {
          this.stats.postsCount = 0;
          return;
        }

        var count = 0;

        for (var key in data) {
          count++;
        }

        this.stats.postsCount = count;
      })
      .catch(err => {
        alert(err.message);
        console.log(err);
      })
  }

  countNewFeedbacks(start, end) {
    firebase.database().ref('feedbacks')
      .orderByChild("timestamp")
      .startAt(start)
      .endAt(end)
      .once("value")
      .then(snapshot => {
        var data = snapshot.val();

        if (!data) {
          this.stats.feedbacksCount = 0;
          return;
        }

        var count = 0;

        for (var key in data) {
          count++;
        }

        this.stats.feedbacksCount = count;
      })
      .catch(err => {
        alert(err.message);
        console.log(err);
      })
  }

  countBannerViews() {
    firebase.database().ref('banners')
      .once("value")
      .then(snapshot => {
        var data = snapshot.val();

        if (!data) {
          this.stats.sponsorViews = 0;
          return;
        }

        var count = 0;

        for (var key in data) {
          count += (data[key].viewCount || 0);
        }

        this.stats.sponsorViews = count;
      })
      .catch(err => {
        alert(err.message);
        console.log(err);
      })
  }

  getMonth(month) {
    switch (month) {
      case 'Jan':
        return 0;
      case 'Feb':
        return 1;
      case 'Mar':
        return 2;
      case 'Apr':
        return 3;
      case 'May':
        return 4;
      case 'Jun':
        return 5;
      case 'Jul':
        return 6;
      case 'Aug':
        return 7;
      case 'Sep':
        return 8;
      case 'Oct':
        return 9;
      case 'Nov':
        return 10;
      case 'Dec':
        return 11;
      default:
        return -1;
    }
  }

}
